import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Matriz_FLOA, obtenerError, Perspectivas, pestel, Planificacion, procesamiento } from '../../../models/Formulacion/indicadores-metas/datos';
import Swal from 'sweetalert2';
import { MatrizRiesgosOportunidadesService } from '../../../services/formulacion/matriz-riesgos-oportunidades/matriz-riesgos-oportunidades.service';
import { messages } from '../../funciones/mensajes';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { MatrizService, TypesMatrizEnum } from '../../../services/gestion/matriz/matriz.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-matriz-riesgos-oportunidades',
  templateUrl: './matriz-riesgos-oportunidades.component.html',
  styleUrl: './matriz-riesgos-oportunidades.component.css'
})
export class MatrizRiesgosOportunidadesComponent implements OnInit {
  public readonly permisos = PERMISOS;

  private planeacionNombre: string;
  public planeacion: Planificacion[] = [];
  public idPlan: number;
  public diccionarioFLOA1: any = [];
  public diccionarioFLOA2: any = [];
  public perspectiva: Perspectivas[] = [];
  public elemento = [];
  public catalogo = pestel.map(p => ({ ...p, id: String(p.id) })); //Convierte los ids del catálogo a string

  public internos = [
    { id: 1, tipoe: 'STRENGTHS', elementoi: 'Fortalezas' },
    { id: 2, tipoe: 'WEAKNESSES', elementoi: 'Debilidades' },
  ];
  public externos = [
    { id: 3, tipoe: 'OPPORTUNITIES', elementoe: 'Oportunidades' },
    { id: 4, tipoe: 'THREATS', elementoe: 'Amenazas' },
  ];

  public esExterno: boolean = false;
  public idelem: number = 0;
  public tipoelem: any; //para el tipo
  public elementt: any; //para el edit
  public modal = false;
  public modal2 = false;
  public viewTablero = false;

  /** Grupo de validación de datos */
  formGeneral = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputNameEdit: new FormControl('', [Validators.required]),
    inputPerspective: new FormControl('', [Validators.required]),
    inputPerspectiveEdit: new FormControl('', [Validators.required]),

    inputNameExt: new FormControl('', [Validators.required]),
    inputNameEditExt: new FormControl('', [Validators.required]),
    inputPerspectiveExt: new FormControl('', [Validators.required]),
    inputPerspectiveEditExt: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });


  constructor(
    public dataService: DataService,
    // private matrizService: MatrizRiesgosOportunidadesService,
    private excelService: ExcelService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private perspectivaService: PerspectivaService,
    private matrizService: MatrizService
  ) {
    this.obtData();
  }

  ngOnInit(): void {

  }

  public async obtData() {
    try {
      //obtener el valor de las cookies
      const planeacionId = this.cookies.get('idInstitucion');
      const plan = await firstValueFrom(this.planificacionService.getPlanificacionById(Number(planeacionId))); 

      if (!plan) {
        return;
      }
      this.idPlan = parseInt(plan.id, 10); //conversion a number

      this.planeacion = [{
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive
      }];

      const perspectivas = await this.perspectivaService.getPerspectivasByIdGQL(Number(plan.id));
      this.perspectiva = [];

      this.perspectiva = perspectivas
        .filter(per => Number(per.planning.id) === this.idPlan)
        .map(per => ({
          nombre: per.name,
          descripcion: per.description,
          planningId: per.planning.id,
          id: per.id
        }));

      this.perspectiva = this.ordenarPerspe(this.perspectiva);
      this.diccionarioFLOA1 = this.internos.map(per => ({
        internosss: per,
        elementooo: [],
        perspectivaaa: this.perspectiva
      }));

      this.diccionarioFLOA2 = this.externos.map(per1 => ({
        externosss: per1,
        elementooo: [],
        perspectivaaa: this.perspectiva
      }));

      const floas = perspectivas.flatMap( e => {
        return e.matrix;
      });

      this.elemento = [];

      this.procesarFLOA(this.diccionarioFLOA1, floas);
      this.procesarFLOA(this.diccionarioFLOA2, floas);

      this.elemento = this.ordenarPerspe(this.elemento);
      this.viewTablero = true;
    } catch (error) {
    }
  }
  private async actualizarDiccionarios() {
    const perspectivas = await this.perspectivaService.getPerspectivasByIdGQL(Number(this.idPlan));
    const floas = perspectivas.flatMap( e => {
      return e.matrix;
    });

    this.elemento = [];

    this.procesarFLOA(this.diccionarioFLOA1, floas);
    this.procesarFLOA(this.diccionarioFLOA2, floas);

    this.elemento = this.ordenarPerspe(this.elemento);
  }

  private procesarFLOA(diccionario: any[], floas: any[]) {
    for (const per of diccionario) {
      per.elementooo = [];
      floas.forEach( (element) =>{
        const ex = per.perspectivaaa.find( p => Number(p.id) === Number(element.perspective.id));
        const ty = element.type === (per.internosss?.tipoe ?? per.externosss?.tipoe);
        
        if(ex && ty && element.name.includes('&&')){
          per.elementooo.push({
            id: element.id,
            tipo: element.type,
            nombre: element.name.split('&&')[0],
            perspectiveId: per.internosss?.tipoe === undefined ? Number(element.name.split('&&')[1]): element.perspective.id
          });
          this.elemento.push(element);
        }
      });
      per.elementooo = this.ordenarPerspe(per.elementooo);
    }
  }

  /* Metodos de ordenamiento */
  private ordenarPerspe(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  /** Guardado de datos */
  public async almacenarD() {
    messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'));
    const esExterno = this.esExterno;
    const nombre = esExterno
      ? this.formGeneral.controls['inputNameExt'].value
      : this.formGeneral.controls['inputName'].value;
    const perspectiva = esExterno
      ? this.formGeneral.controls['inputPerspectiveExt'].value
      : this.formGeneral.controls['inputPerspective'].value;

    const element = new Matriz_FLOA();
    element.tipo = TypesMatrizEnum[this.tipoelem];
    element.nombre = esExterno
      ? `${nombre}&&${perspectiva}`
      : `${nombre}&&`;
    element.perspectiveId = esExterno ? Number(this.perspectiva[0].id):Number(perspectiva);

    try {
      await lastValueFrom(this.matrizService.postFLOA(element));
      this.actualizarDiccionarios();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.matRiesOport.infoAgregada'));
    } catch (error) {
      const er = obtenerError.errorObt(error['error'].message);
      messages.errorMessageGraph(er);
    }
    this.cerrarForm();
  }

  public async almacenarDatosEdit() {
    messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));

    const esExterno = this.esExterno;
    const nombre = esExterno
      ? this.formGeneral.controls['inputNameEditExt'].value
      : this.formGeneral.controls['inputNameEdit'].value;
    const perspectiva = esExterno
      ? this.formGeneral.controls['inputPerspectiveEditExt'].value
      : this.formGeneral.controls['inputPerspectiveEdit'].value;

    const item = new Matriz_FLOA();
    item.id = this.elementt.id;
    item.tipo = TypesMatrizEnum[this.elementt.tipo];
    item.nombre = esExterno
      ? `${nombre}&&${perspectiva}`
      : `${nombre}&&`;
    item.perspectiveId = esExterno ? Number(this.perspectiva[0].id):Number(perspectiva);

    try {
      await lastValueFrom(this.matrizService.patchFLOA(item));
      this.actualizarDiccionarios();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.matRiesOport.infoActualizada'));
    } catch (error) {
      const er = obtenerError.errorObt(error['error'].message);
      messages.errorMessageGraph(er);
    }
    this.cerrarForm();
  }

  /** Eliminar datos */
  public async eliminarele(ele: any) {
    messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
    try {
      await lastValueFrom(this.matrizService.deleteFLOA(ele));
      this.actualizarDiccionarios();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.matRiesOport.infoEliminada'));
    } catch (error) {
      const er = obtenerError.errorObt(error['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  /** Metodo de deción de guardado de datos */
  public async alertas(aler: any, ele?: any) {
    if (aler === 'editar') {
          this.almacenarDatosEdit();
    } else if (aler === 'guardar') {
          this.almacenarD();
    } else if (aler === 'eliminar') {

      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarEliminar'),
        `${ele.nombre}`,
        this.translate
      );
      if (result) {
        this.eliminarele(ele);
      }
    }
  }

  /** Desición de guardado */
  public puede_guardar() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputName'].value;
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspective'].value);
    let perspectivaValue = this.formGeneral.controls['inputPerspective'].value;


    if (element.nombre != '' && perspectivaValue !== 'default' && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarExt() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputNameExt'].value;
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspectiveExt'].value);
    let pestelValue = this.formGeneral.controls['inputPerspectiveExt'].value;

    if (element.nombre != '' && pestelValue !== 'default' && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEdit() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputNameEdit'].value
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspectiveEdit'].value);
    if (element.nombre != '' && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEditExt() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputNameEditExt'].value;
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspectiveEditExt'].value);

    if (element.nombre != '' && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  /** Obtención de los codigos */
  public obtCodigo(inter: any) {
    switch (inter.id) {
      case 1: return 'F';
      case 2: return 'D';
      case 3: return 'O';
      case 4: return 'A';
    }
    return 'no';
  }

  /** Modales */
  // Abrir elementos internos
  public abrirFormAgregar(elem: any, externo: boolean) {
    this.formGeneral.reset();

    this.idelem = elem.id;
    this.tipoelem = elem.tipoe;
    this.esExterno = externo;

    if (!this.esExterno) {
      this.formGeneral.controls['inputPerspective'].setValue('default'); //para que siempre se muestre la opcion por default
    } else {
      this.formGeneral.controls['inputPerspectiveExt'].setValue('default'); //para que siempre se muestre la opcion por default
    }
    // document.getElementById('formularioAgregar')!.style.display = 'block';
    this.modal = true;
  }

  public abrirFormEdit(ele: any, eleme: any, externo: boolean) {
    this.elementt = ele;
    this.idelem = eleme.id;
    this.esExterno = externo;
    if (externo) {
      this.formGeneral.controls['inputNameEditExt'].setValue(this.elementt.nombre);
      this.formGeneral.controls['inputPerspectiveEditExt'].setValue(this.elementt.perspectiveId);
    } else {
      this.formGeneral.controls['inputNameEdit'].setValue(this.elementt.nombre);
      this.formGeneral.controls['inputPerspectiveEdit'].setValue(this.elementt.perspectiveId);
    }
    // document.getElementById('formularioEditar')!.style.display = 'block';
    this.modal2 = true;
  }

  // Cerrar
  public cerrarForm() {
    this.modal = false;
    this.modal2 = false;
    // document.getElementById('formularioAgregar')!.style.display = 'none';
    // document.getElementById('formularioEditar')!.style.display = 'none';
    this.formGeneral.reset();
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }

  /** Exportación */
  public exportar_excel() {
    let title = this.translate.instant('gestion.formulacion.matRiesOport.tituloExcel');
    let subtituloElementosInternos = this.translate.instant('gestion.formulacion.matRiesOport.elementosInternos');
    let headersInternos = [];
    let elementosInternos = [];
    for (let i = 0; i < this.diccionarioFLOA1.length; i++) {
      let header = [];
      headersInternos.push('#');
      headersInternos.push(this.diccionarioFLOA1[i].internosss.elemento);
      headersInternos.push('');
      let elemento = [];
      for (let j = 0; j < this.diccionarioFLOA1[i].elementooo.length; j++) {
        let col1 = this.obtCodigo(this.diccionarioFLOA1[i].internosss).concat('' + (j + 1));
        elemento.push([col1, this.diccionarioFLOA1[i].elementooo[j].nombre]);

      }

      elementosInternos.push(elemento);
    }

    let subtituloElementosExternos = this.translate.instant('gestion.formulacion.matRiesOport.elementosExternos');
    let headersExternos = [];
    let elementosExternos: any = [];
    for (let i = 0; i < this.diccionarioFLOA1.length; i++) {
      let header = [];
      headersExternos.push('#');
      headersExternos.push(this.diccionarioFLOA2[i].externosss.elemento);
      headersExternos.push('');
      let elemento = [];
      for (let j = 0; j < this.diccionarioFLOA2[i].elementooo.length; j++) {
        let col1 = this.obtCodigo(this.diccionarioFLOA2[i].externosss).concat('' + (j + 1));
        elemento.push([col1, this.diccionarioFLOA2[i].elementooo[j].nombre]);
      }
      elementosExternos.push(elemento);
    }

    this.excelService.generateExcelMatrizFoda(title, headersInternos, headersExternos, elementosInternos, elementosExternos, 'matriz_foda', subtituloElementosInternos, subtituloElementosExternos);
  }

  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = ""
      if (this.modal) {
        nombre = this.esExterno
          ? formGroup.get('inputNameExt')?.value || ''
          : formGroup.get('inputName')?.value || '';
      } else if (this.modal2) {
        nombre = this.esExterno
          ? formGroup.get('inputNameEditExt')?.value || ''
          : formGroup.get('inputNameEdit')?.value || '';
      }
      nombre = nombre.trim();
      const existe = this.elemento.find(element => {
        if (this.modal2) {
          return (procesamiento.procesamiento_Texto(element.name.split('&&')[0]).toLowerCase() === nombre.toLowerCase() && element.id !== this.elementt.id);
        }
        return (procesamiento.procesamiento_Texto(element.name.split('&&')[0]).toLowerCase() === nombre.toLowerCase());
      });
      if (existe) return { isValid: true };
      return null;
    };
  }
  public nombreExiste(): boolean {
    return this.formGeneral.hasError('isValid');
  }
}
